var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ELSCommonUIConstants } from 'components/common';
import { analyticBaseConfig } from 'config/app.config';
import { ROUTE_ROLES } from 'constants/app.constant';
import { lazy } from 'react';
import { CW_PRODUCT_NAME, PerformancePath } from '../constants/cw.constant';
var INSTRUCTOR = ROUTE_ROLES.INSTRUCTOR;
var studentDetailRoutes = [
    PerformancePath.assignmentEngagement.byStudent,
    PerformancePath.studentEngagement.studentDetail,
    PerformancePath.gradeBook.studentDetail,
    PerformancePath.disengagedStudent.studentDetail,
    PerformancePath.eaqTopicReport.studentDetail,
    PerformancePath.studentDetail
];
export var CwRoutes = {
    getRoutes: function () { return __spreadArray(__spreadArray([
        {
            path: PerformancePath.oldHomepage,
            component: lazy(function () { return import(/* webpackChunkName: "CWOldHomePage" */ 'reports/cw/components/pages/old-instructor-home/InstructorHomeComponent'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-old-home-page"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.courseAggregate,
            component: lazy(function () { return import(/* webpackChunkName: "CWCourseAggregatePage" */ 'reports/cw/components/pages/course-aggregate/CourseAggregate'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-course-aggregate-page"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.disengagedStudent.home,
            component: lazy(function () { return import(/* webpackChunkName: "CWDisengagedStudent" */ 'reports/cw/components/pages/disengaged-student/DisengagedStudent'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-disengaged-student"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            exact: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.engagement.home,
            component: lazy(function () { return import(/* webpackChunkName: "CWEngagement" */ 'reports/cw/components/pages/engagement/Engagement'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-engagement"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.engagementSummary,
            component: lazy(function () { return import(/* webpackChunkName: "CWEngagementSummary" */ 'reports/cw/components/pages/engagement-summary/EngagementSummary'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-engagement-summary"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.assignmentDetail,
            component: lazy(function () { return import(/* webpackChunkName: "CWAssignmentDetail" */ 'reports/cw/components/pages/assignment-detail/AssignmentDetailComponent'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-assignment-detail"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.assignmentEngagement.byAssignment,
            component: lazy(function () { return import(/* webpackChunkName: "CWAssignmentEngagement" */ 'reports/cw/components/pages/assignment-engagement/AssignmentEngagement'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-assignment-engagement"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.assignmentSummary,
            component: lazy(function () { return import(/* webpackChunkName: "CWAssignmentSummary" */ 'reports/cw/components/pages/assignment-summary/AssignmentSummary'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-assignment-summary"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.assessmentSummary,
            component: lazy(function () { return import(/* webpackChunkName: "CWAssessmentSummary" */ 'reports/cw/components/pages/assessment-summary/AssessmentSummaryView'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-assessment-summary")
                }
            },
            isPrivate: true,
            exact: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.assessmentDetail,
            component: lazy(function () { return import(/* webpackChunkName: "CWAssessmentDetail" */ 'reports/cw/components/pages/assessment-detail/AssessmentDetail'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-assessment-detail")
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.studentEngagement.summary,
            component: lazy(function () { return import(/* webpackChunkName: "CWStudentEngagement" */ 'reports/cw/components/pages/student-engagement/StudentEngagement'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-student-engagement"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: PerformancePath.gradeBook.home,
            component: lazy(function () { return import(/* webpackChunkName: "CWGradebook" */ 'reports/cw/components/pages/gradebook/Gradebook'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":cw-gradebook"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        }
    ], studentDetailRoutes.map(function (route) { return ({
        path: route,
        component: lazy(function () { return import(/* webpackChunkName: "CWStudentDetail" */ 'reports/cw/components/pages/student-detail/StudentDetailComponent'); }),
        data: {
            analytics: {
                pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                pageName: "".concat(analyticBaseConfig.edApp, ":cw-student-detail"),
                pageProductName: CW_PRODUCT_NAME
            }
        },
        isPrivate: true,
        roles: INSTRUCTOR
    }); }), true), [
        {
            path: PerformancePath.eaqTopicReport.home,
            component: lazy(function () { return import(/* webpackChunkName: "EAQTopicReport" */ 'reports/cw/components/pages/eaq-topic-report/EAQTopicReport'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":eaq-topic-report"),
                    pageProductName: CW_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        }
    ], false); }
};
